import { APP_ID, ApplicationConfig, ErrorHandler, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, Router, Routes, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { provideClientHydration, withEventReplay, withIncrementalHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { DecimalPipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { provideNgxMask } from 'ngx-mask';
import { GlobalErrorHandler } from './core/helpers/global-error-handler';
import { provideInitializer } from './core/initializer/initializer-queue';
import { CacheControlInterceptor } from './core/interceptors/cache-control.interceptor';
import { provideStoreInitializer } from 'ngx-unificator/store';
import { GlobalStore } from './core/store';
import { HostRequestsInterceptor } from './core/interceptors/host-requests.interceptor';
import { provideBrandConfig } from './core/services/brand-config/brand-config.provider';
import { apolloProvider } from './core/services/graphql/graphql.provider';
import { onViewTransitionCreated } from './core/services/view-transition.service';
import { provideBotRules } from './core/providers/bot-rules.provider';
import { provideRestrictRedirect } from './core/providers/restrict-redirect.provider';
import { CustomTransferCacheInterceptor } from './core/interceptors/custom-transfer-cache.interceptor';
import * as Sentry from '@sentry/angular';

const routes: Routes = [
  {
    path: '',
    children: [{ path: '', loadChildren: () => import('./page/page.module').then(m => m.PageModule) }],
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideStoreInitializer(GlobalStore),
    provideInitializer(),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideBrandConfig(),
    provideBotRules(),
    provideRestrictRedirect(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      }),
      withViewTransitions({ onViewTransitionCreated })
    ),
    provideClientHydration(withIncrementalHydration(), withEventReplay(), withNoHttpTransferCache()),
    provideZonelessChangeDetection(),
    provideNgxMask(),
    apolloProvider(),
    DecimalPipe,
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheControlInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HostRequestsInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomTransferCacheInterceptor,
      multi: true,
    },
    { provide: APP_ID, useValue: 'lets_go_casino' },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
  ],
};
